import { http } from './config';

export default {

    // ─── CATEGORÍAS ─────────────────────────────────────────────
    listarCategorias: () => {
        return http.get('api/events/categories');
    },
    saveCategoria: (data) => {
        return http.post('api/events/categories', data);
    },
    updateCategoria: (id, data) => {
        return http.put('api/events/categories/' + id, data);
    },
    deleteCategoria: (id) => {
        return http.delete('api/events/categories/' + id);
    },

    // ─── ORGANIZADORES ──────────────────────────────────────────
    listarOrganizadores: () => {
        return http.get('api/events/organizers');
    },
    saveOrganizador: (data) => {
        return http.post('api/events/organizers', data);
    },
    updateOrganizador: (id, data) => {
        return http.put('api/events/organizers/' + id, data);
    },
    deleteOrganizador: (id) => {
        return http.delete('api/events/organizers/' + id);
    },
    uploadLogo: (id, formData) => {
        return http.post('api/events/organizers/' + id + '/logo', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    getLogoUrl: (id, filename) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/events/organizers/' + id + '/logo/' + filename;
    },

    // ─── EVENTOS ────────────────────────────────────────────────
    listarEventos: (params) => {
        return http.get('api/events', { params });
    },
    listarEventosAdmin: (params) => {
        return http.get('api/events/admin', { params });
    },
    getEvento: (slug) => {
        return http.get('api/events/' + slug);
    },
    saveEvento: (data) => {
        return http.post('api/events', data);
    },
    updateEvento: (id, data) => {
        return http.put('api/events/' + id, data);
    },
    deleteEvento: (id) => {
        return http.delete('api/events/' + id);
    },
    uploadImage: (id, formData) => {
        return http.post('api/events/' + id + '/image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    getImageUrl: (id, filename) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/events/' + id + '/image/' + filename;
    },
    downloadIcsUrl: (id) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/events/' + id + '/ics';
    },

    // ─── AGENDA (usuario autenticado) ───────────────────────────
    agendarEvento: (eventId, data) => {
        return http.post('api/events/' + eventId + '/schedule', data || {});
    },
    desagendarEvento: (eventId) => {
        return http.delete('api/events/' + eventId + '/schedule');
    },
    checkAgendado: (eventId) => {
        return http.get('api/events/' + eventId + '/schedule/check');
    },
    miAgenda: (params) => {
        return http.get('api/events/my-schedule', { params });
    },
};
